import {
    faCalculator,
    faDollarSign,
    faPlus
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import React, { Fragment, useRef } from 'react'
import { withRouter } from 'react-router-dom'

import ModalArticulosVenta from '../ConsolaVenta/ArticuloModalVentas/ModalArticuloVenta'
import Header from '../Header/Header'
import BotonBack from '../Utiles/BotonBack'
import Subtitulo from '../Utiles/Subtitulo'
import useCreateArticuloPrecio from './hooks/useCreateArticuloPrecio'
import "./styles/index.css"

function AddListasPrecios({ history }) {
    const listaPrecioId = history.location?.state?.listaPrecioId ?? ''
    const { initialValues, validationSchema, onSubmit } = useCreateArticuloPrecio(history, listaPrecioId)
    const inputTotalRef = useRef()

    return (
        <Fragment>
            <Header />
            <div className="container-fluid mt-3">
                <div className="alert alert-dismissible alert-secondary d-flex justify-content-between">
                    <BotonBack />
                    <Subtitulo icon={faCalculator} title={'Precio de artículo'} />
                </div>

                <div className="bg-gris p-4">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                    >
                        {({ isSubmitting, setFieldValue }) => (
                            <Form>
                                <div className="form-row">
                                    <div className="form-group col-md-6">
                                        <label htmlFor="codigoArticulo">Código de artículo</label>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <ModalArticulosVenta
                                                    setCodigoAndCantidad={(value) => {
                                                        setFieldValue('codigoArticulo', value)
                                                    }}
                                                    inputTotalRef={inputTotalRef}
                                                    listaPrecio={listaPrecioId}
                                                />
                                            </div>
                                            <Field
                                                type="text"
                                                id="codigoArticulo"
                                                name="codigoArticulo"
                                                className="form-control"
                                                placeholder="Buscar artículo..."
                                                innerRef={inputTotalRef}
                                            />
                                        </div>
                                        <small className="form-text text-danger">
                                            <ErrorMessage name="codigoArticulo" />
                                        </small>
                                    </div>

                                    <div className="form-group col-md-6">
                                        <label htmlFor="precio">Precio</label>
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text" id="inputGroupPrepend">
                                                    <FontAwesomeIcon icon={faDollarSign} />
                                                </span>
                                            </div>
                                            <Field
                                                type="number"
                                                id="precio"
                                                name="precio"
                                                className="form-control"
                                                placeholder="Ej. $100"
                                                step="any"
                                            />
                                        </div>
                                        <small className="form-text text-danger">
                                            <ErrorMessage name="precio" />
                                        </small>
                                    </div>
                                </div>

                                <div className="text-center">
                                    <button
                                        type="submit"
                                        className="btn btn-outline-success"
                                        disabled={isSubmitting}
                                    >
                                        <FontAwesomeIcon icon={faPlus} /> Crear precio de artículo
                                    </button>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </Fragment>
    )
}

export default withRouter(AddListasPrecios)
